// This file is in progress and behind a feature flag, please see the following issue for more:
// https://gitlab.com/gitlab-org/gitlab/-/issues/323200
import BlobContentViewer from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/blob_content_viewer.vue?vue3';
import repositoryPathMixin from '../mixins/repository_path';
export default {
    name: 'RepositoryBlob',
    components: {
        BlobContentViewer
    },
    mixins: [
        repositoryPathMixin
    ],
    props: {
        projectPath: {
            type: String,
            required: true
        },
        refType: {
            type: String,
            required: false,
            default: null
        }
    }
};
